<template>
  <div class="package-category-editor">
    <div class="row">
      <div class="col image-container">
        <label class="label">รูป Icon</label>
        <img class="thumbnail" :src="modalImageUrl" />
        <sc-button
          class="thumbnail-button"
          @click="handleClickChooseImageButton"
        >เลือกรูป Icon​</sc-button>
      </div>
      <div class="col info-editor">
        <label class="label">ชื่อ</label>
        <el-input class="input" v-model="value.name"></el-input>
        <label class="label">รายการ Package</label>
        <ruejai-club-package-selector
          class="input"
          v-model="value.packages"
          :disabled="disabled"
        ></ruejai-club-package-selector>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import RuejaiClubPackageSelector from "@/lib/components/RuejaiClubPackageSelector/RuejaiClubPackageSelector";

export default {
  props: ["value", "iconUrl", "disabled"],
  components: {
    ScButton,
    ImagePickerModal,
    RuejaiClubPackageSelector,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option
  },
  data() {
    return {
      isShowModal: false
    };
  },
  computed: {
    modalImageUrl() {
      if (!this.chooseImageDialog.thumbnailUrl) {
        return "https://placehold.co/300";
      }

      return this.chooseImageDialog.thumbnailUrl;
    },
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Icon",
        width: 300,
        height: 300,
        recommendWidth: 300,
        recommendHeight: 300,
        thumbnailFile: this.value.iconFile,
        thumbnailUrl: this.iconUrl
      };
    }
  },
  methods: {
    handleClickChooseImageButton() {
      this.isShowModal = true;
    },
    handleCancelChooseImageDialog() {
      this.isShowModal = false;
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file });
      this.isShowModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-category-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/category/components/PackageCategoryEditor.vue